import type { IconButtonProps } from '@mui/material/IconButton';

import { m } from 'framer-motion';

import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';
import { varTap, varHover, transitionTap } from 'src/components/animate';

// ----------------------------------------------------------------------

export type ContactsPopoverProps = IconButtonProps & {
  data?: {
    id: string;
    role: string;
    name: string;
    email: string;
    status: string;
    address: string;
    avatarUrl: string;
    phoneNumber: string;
    lastActivity: string;
  }[];
};

export function ChatAssignedTo({ data = [], sx, ...other }: ContactsPopoverProps) {
  const { t } = useTranslate('translation');

  const router = useRouter();

  const handleButtonClick = () => {
    router.replace(paths.setting.user.root);
  };

  return (
    <Tooltip title={t('INVITE_USER')} placement="bottom" arrow>
      <IconButton
        component={m.button}
        whileTap={varTap(0.96)}
        whileHover={varHover(1.04)}
        transition={transitionTap()}
        aria-label={t('CONTACTS_BTN')}
        onClick={handleButtonClick}
        sx={[...(Array.isArray(sx) ? sx : [sx])]}
        {...other}
      >
        <Iconify icon="mingcute:user-add-2-fill" />
      </IconButton>
    </Tooltip>
  );
}
